// extracted by mini-css-extract-plugin
module.exports = {"popup":"_025a50318d--popup--2xCIi"};